export default __webpack_public_path__ + "static/icon-fullscreen-overlays-f41447a51244e3ec9a37c77948f9a049.png";